import { useEffect, useState } from 'react';

type Listener = (isDeploying: boolean) => void;

let state = false;
const listeners = new Set<Listener>();

export function getDeployStatus(): boolean {
  return state;
}

export function setDeployStatus(next: boolean): void {
  if (state === next) return;
  state = next;
  listeners.forEach((l) => l(next));
}

export function subscribeDeployStatus(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useDeployStatus(): boolean {
  const [value, setValue] = useState<boolean>(getDeployStatus);
  useEffect(() => subscribeDeployStatus(setValue), []);
  return value;
}
